/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  DataResponseListTaxForm,
  DataResponseTaxFormRead,
  ErrorResponse,
  HTTPValidationError,
  TaxFormCreate,
  TaxWebhookPayload,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get participant tax forms from TTS
 * @summary Get Tax Forms
 */
export const getTaxFormsTaxUsFormsGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListTaxForm>(
    { url: `/tax/us/forms`, method: "GET", signal },
    options
  );
};

export const getGetTaxFormsTaxUsFormsGetQueryKey = () => {
  return [`/tax/us/forms`] as const;
};

export const getGetTaxFormsTaxUsFormsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTaxFormsTaxUsFormsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>
  > = ({ signal }) => getTaxFormsTaxUsFormsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaxFormsTaxUsFormsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>
>;
export type GetTaxFormsTaxUsFormsGetQueryError = ErrorType<ErrorResponse>;

export function useGetTaxFormsTaxUsFormsGet<
  TData = Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
          TError,
          Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaxFormsTaxUsFormsGet<
  TData = Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
          TError,
          Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaxFormsTaxUsFormsGet<
  TData = Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tax Forms
 */

export function useGetTaxFormsTaxUsFormsGet<
  TData = Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaxFormsTaxUsFormsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaxFormsTaxUsFormsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create TTS tax form for USA participants
 * @summary Create Tax Form
 */
export const createTaxFormTaxUsFormsPost = (
  taxFormCreate: BodyType<TaxFormCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseTaxFormRead>(
    {
      url: `/tax/us/forms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: taxFormCreate,
      signal,
    },
    options
  );
};

export const getCreateTaxFormTaxUsFormsPostMutationKey = () =>
  ["createTaxFormTaxUsFormsPost"] as const;

export const getCreateTaxFormTaxUsFormsPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>,
    TError,
    CreateTaxFormTaxUsFormsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>,
  TError,
  CreateTaxFormTaxUsFormsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateTaxFormTaxUsFormsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>,
    CreateTaxFormTaxUsFormsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createTaxFormTaxUsFormsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaxFormTaxUsFormsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>
>;
export type CreateTaxFormTaxUsFormsPostMutationBody = BodyType<TaxFormCreate>;
export type CreateTaxFormTaxUsFormsPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CreateTaxFormTaxUsFormsPostMutationVariables {
  data: BodyType<TaxFormCreate>;
}

/**
 * @summary Create Tax Form
 */
export const useCreateTaxFormTaxUsFormsPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>,
      TError,
      CreateTaxFormTaxUsFormsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTaxFormTaxUsFormsPost>>,
  TError,
  CreateTaxFormTaxUsFormsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateTaxFormTaxUsFormsPostMutationOptions(options),
    queryClient
  );
};
/**
 * Process tax compliance webhook from TTS
 * @summary Tax Webhook
 */
export const taxWebhookTaxWebhookPost = (
  taxWebhookPayload: BodyType<TaxWebhookPayload>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/tax/webhook`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: taxWebhookPayload,
      signal,
    },
    options
  );
};

export const getTaxWebhookTaxWebhookPostMutationKey = () =>
  ["taxWebhookTaxWebhookPost"] as const;

export const getTaxWebhookTaxWebhookPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>,
    TError,
    TaxWebhookTaxWebhookPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>,
  TError,
  TaxWebhookTaxWebhookPostMutationVariables,
  TContext
> => {
  const mutationKey = getTaxWebhookTaxWebhookPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>,
    TaxWebhookTaxWebhookPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return taxWebhookTaxWebhookPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TaxWebhookTaxWebhookPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>
>;
export type TaxWebhookTaxWebhookPostMutationBody = BodyType<TaxWebhookPayload>;
export type TaxWebhookTaxWebhookPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface TaxWebhookTaxWebhookPostMutationVariables {
  data: BodyType<TaxWebhookPayload>;
}

/**
 * @summary Tax Webhook
 */
export const useTaxWebhookTaxWebhookPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>,
      TError,
      TaxWebhookTaxWebhookPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof taxWebhookTaxWebhookPost>>,
  TError,
  TaxWebhookTaxWebhookPostMutationVariables,
  TContext
> => {
  return useMutation(
    getTaxWebhookTaxWebhookPostMutationOptions(options),
    queryClient
  );
};
